import {MouseEventHandler} from "react";
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {styled, SpacialFn, VisualFn} from '@yosmanyga/web-style'
import {IconProps} from '@yosmanyga/primitive-ui-spec'

const Icon = ({
  component,
  width, color,
  onClick,
  className
}: IconProps<
  MouseEventHandler<SVGSVGElement>
> & UnnormalizedStyleProps) => {
  width = SpacialFn.normalizeWidth(width)

  return <component.type
    size={width?.def}
    color={color}
    onClick={onClick}
    className={className}
  />
}

const StyledIcon = styled(Icon)`
  ${({align}) => SpacialFn.compileAlign(align)}
  ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}

   &:hover {
    ${({pseudo}) => VisualFn.compileFill(pseudo?.hover?.fill)}
   }
`

export default StyledIcon
